import { useEffect, useState } from 'react';

/**
 * "The numbers changed" bus. A LightSpeed sync (auto or manual) replaces the
 * data under every open card, so instead of reloading the browser we bump a
 * counter: `useApi` re-runs its fetcher and each page repaints with the fresh
 * figures. Module state, no provider — every page already imports useApi.
 */
let version = 0;
const subscribers = new Set();

export const dataVersion = () => version;

export function bumpDataVersion() {
  version += 1;
  subscribers.forEach((fn) => fn(version));
}

/** Returns an unsubscribe function (usable straight from useEffect). */
export function subscribeDataVersion(fn) {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
}

export function useDataVersion() {
  const [v, setV] = useState(version);
  useEffect(() => subscribeDataVersion(setV), []);
  return v;
}
